import { makeAutoObservable } from 'mobx';

import { resetAllStore } from '../../shared/stores/resetAllStore';
import { FilterStore } from '../../shared/util-stores';
import {
  ChallengeInfo,
  LeaderboardRowInfo,
} from '../interfaces/leaderboard/LeaderboardRowInfo';
import {
  LeaderboardListFilters,
  LeaderboardFilterValues,
  LeaderboardListSortField,
} from '../interfaces/leaderboard/LeaderboardListFilters';
import { leaderboardService } from '../services/leaderboardService';

class LeaderboardStore {
  leaderboardList: LeaderboardRowInfo[] = [];
  challengeInfo: ChallengeInfo | null = null;
  filterMethods: FilterStore<LeaderboardFilterValues, LeaderboardListSortField>;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });

    this.filterMethods = new FilterStore<
      LeaderboardFilterValues,
      LeaderboardListSortField
    >(this.handleGetLeaderboardList);
  }

  setDefaultValues() {
    this.leaderboardList = [];
    this.challengeInfo = null;
    this.filterMethods.setDefaultValues();
  }

  async getChallengeInfo(challengeId: number) {
    const info = await leaderboardService.getChallengeInfo(challengeId);
    this.setChallengeInfo(info);
    return info;
  }

  private async handleGetLeaderboardList(filterInfo: LeaderboardListFilters) {
    if (!this.challengeInfo?.id) {
      throw new Error('Challenge info is required to fetch leaderboard data');
    }

    const data = await leaderboardService.getLeaderboardList(
      this.challengeInfo.id,
      filterInfo,
    );
    const { content } = data;

    this.setLeaderboardList(content);

    return data;
  }

  async getLeaderboardList() {
    return this.filterMethods.getData();
  }

  private setLeaderboardList(leaderboardList: LeaderboardRowInfo[]) {
    this.leaderboardList = leaderboardList;
  }

  private setChallengeInfo(challengeInfo: ChallengeInfo) {
    this.challengeInfo = challengeInfo;
  }
}

const leaderboardStore = new LeaderboardStore();

resetAllStore.addResetMethod(leaderboardStore.setDefaultValues);

export { leaderboardStore, LeaderboardStore };
